import React from 'react'
import styled from '@emotion/styled'

import Dropdown from '../generic/floatingDropdown'
import { useStateValue } from '../../hooks'
import { FlexRowDiv } from '../generic/Basics'

let yearUpdated = false

const mmQ = 'qrv/MakeModel1'
const vvQ = 'qrv/VoiVin'
const mdlQ = 'qrv/Model'
const yrQ = 'qrv/YearRange'

export default ({ prospectDocuments, getQuestionResponseComment, saveMultipleQuestionRaw, updateGlobalState }) => {
  const modelValue = getQuestionResponseComment(mmQ)

  const [make, setMake] = useStateValue(
    modelValue
      ? modelValue
          .split('/')
          .slice(0, 2)
          .join('/')
      : ''
  )
  const dataPack = prospectDocuments && prospectDocuments.documents && prospectDocuments.documents.find(document => document.canonicalName === 'replacementVehicle/supplement')

  const yearRange = dataPack && dataPack.items['yearRange'].values
  const rvMakesModels = dataPack && dataPack.items['makesModels'].values
  const rvModels = rvMakesModels && make ? rvMakesModels.find(mm => mm.id === make || mm.id === make.id).values : []

  const minYear = yearRange ? yearRange[1].label : 0
  const maxYear = yearRange ? yearRange[2].label : -1
  const yrValue = getQuestionResponseComment(yrQ) && getQuestionResponseComment(yrQ).split(',')

  //set default yr value only if user hasn't interacted with year ranges
  if (!yearUpdated && !getQuestionResponseComment(yrQ) && minYear > 0) {
    saveMultipleQuestionRaw([yrQ, vvQ], [{ c: +minYear + ',' + +maxYear }, { c: undefined }])
  }

  const [lowYear, setLowYear] = useStateValue(yrValue ? yrValue[0] : yearRange ? minYear : '')
  const [highYear, setHighYear] = useStateValue(yrValue ? yrValue[1] : yearRange ? maxYear : '')

  const updateFromYear = ({ target: { value } }) => {
    setLowYear(value)
    saveYearToUrlHash(value <= highYear && value > 0 && +value + ',' + +highYear)
    fireAnalytics('From Year')
  }

  const updateToYear = ({ target: { value } }) => {
    setHighYear(value)
    saveYearToUrlHash(lowYear <= value && lowYear > 0 && +lowYear + ',' + +value)
    fireAnalytics('To Year')
  }

  const fireAnalytics = text => updateGlobalState({ fireAnalytics: `voi_update:${text}/` })

  const saveYearToUrlHash = value => {
    yearUpdated = true
    saveMultipleQuestionRaw([yrQ, vvQ], [{ c: value }, { c: undefined }])
  }

  const years = Array.from(Array(+maxYear - +minYear + 1).keys(), i => {
    return { displayName: +i + +minYear }
  }).reverse()

  const updateMake = e => {
    setMake(e.target.value)
    saveMultipleQuestionRaw(['qrv/Make', vvQ, mmQ, mdlQ], [{ c: e.target[e.target.selectedIndex].text }, { c: undefined }, { c: undefined }, { c: undefined }])
    fireAnalytics('Make')
  }

  const updateModel = e => {
    saveMultipleQuestionRaw([mmQ, mdlQ, vvQ], [{ c: e.target.value }, { c: e.target[e.target.selectedIndex].text }, { c: undefined }])
    fireAnalytics('Model')
  }

  return (
    <>
      <StyledContainer>
        <StyledYMDiv>
          <Dropdown id="FromYear" testId="ci-dr-ymm-from-year" label="Year" currentValue={lowYear} options={years} onChange={updateFromYear} textProp="displayName" valueProp="displayName" fullWidth={true} />
          <SpacerDiv>to</SpacerDiv>
          <Dropdown id="ToYear" testId="ci-dr-ymm-to-year" label="Year" currentValue={highYear} options={years.filter(i => +i.displayName >= +lowYear)} onChange={updateToYear} textProp="displayName" valueProp="displayName" fullWidth={true} />
        </StyledYMDiv>
        <FullWidth>
          <Dropdown fullWidth testId="ci-dr-ymm-make" label="Make" currentValue={make} options={rvMakesModels} id="Make" onChange={updateMake} textProp="label" valueProp="id" />
        </FullWidth>
        <FullWidth>
          <Dropdown fullWidth testId="ci-dr-ymm-model" label="Model" currentValue={make ? { id: modelValue } : ''} options={rvModels} id="Model" onChange={updateModel} textProp="label" valueProp="id" />
        </FullWidth>
      </StyledContainer>
    </>
  )
}

const StyledYMDiv = styled(FlexRowDiv)`
  width: 100%;
`

const StyledContainer = styled(FlexRowDiv)`
  width: 100%;
  flex-wrap: wrap;
  max-width: 305px;
`

const FullWidth = styled.div`
  margin-top: 16px;
  width: 100%;
`

const SpacerDiv = styled.div`
  margin: 8px;
`
